<template>
  <div class="place_body">
    <div class="tupian">
      <img src="/6.jpeg">
    </div>
    <!--    <div class="xianshi">限时福利！立减20元</div>-->

        <div>
          <div>黄梅戏初级教程</div>
          <div>授课老师：罗超</div>
          <div>黄梅戏初级教程</div>
        </div>
        <div style="width: 100%;height: 9px;background:#f8f8f8; "></div>
        <div class="xiangqing">课程详情</div>
        <div class="xi">黄梅戏与京剧、越剧、评剧 、豫剧并称“中国五大戏曲剧种”，也是安徽省的主要地方戏曲剧种，湖北、江西、福建、浙江、江苏、香港、
          台湾等地亦有黄梅戏的专业或业余的演出团体，
          受到广泛的欢迎
        </div>
        <div class="xiangqingtu" v-for="item in 5">
          <img src="/6.jpeg">
        </div>


    <van-goods-action>
      <van-goods-action-icon icon="chat-o" text="客服" color="#07c160" />
      <van-goods-action-icon icon="cart-o" text="购物车" />
      <van-goods-action-icon icon="star" text="已收藏" color="#ff5000" />
      <van-goods-action-button type="warning" text="加入购物车" />
      <van-goods-action-button type="danger" text="立即购买" />
    </van-goods-action>

  </div>
</template>

<script>
    export default {
        name: "bank",
        data() {
            return {
                activeName: 'a',
                value: ['1'],
                inputt:''
            }
        },
        created() {

        },
        methods:{

        }
    }
</script>

<style scoped lang="stylus">
  .place_body {
    width 100%;
    position relative;
    .foot{
      width 95%;
      margin auto;
      display flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      position fixed;
      bottom 0px;
      .shuru{
        width 85%;
      }
      .anniu{
        width 10%;
      }
    }
    .tupian {
      width 100%;

      img {
        width 100%;
        height 250px;
      }
    }

    .xiangqing {
      font-weight 500;
      font-size 16px;
      color #333333;
      width 90%;
      margin 10px auto;
    }

    .xi {
      width 90%;
      margin 10px auto;
      line-height 1.5
    }

    .xiangqingtu {
      width 90%;
      margin 10px auto;

      img {
        width 100%;
        height 150px;
      }
    }

    .shiping {
      position relative;
      margin-top 10px;

      >>> .van-collapse-item__content {
        padding 0px;
      }
      width 90%;
      margin 10px auto;
      display flex;

      .xiabiao {
        margin-right 10px;
      }

      .kecheng {

      }

      .bofang {
        position absolute;
        right 0px;

        img {
          width 20px;
          height 20px;
        }
      }
    }

    .pinglun {
      width 90%;
      margin 10px auto;
      display flex

      .touxiang {
        margin-top 10px;
        img {
          width 50px;
          height 50px;
          border-radius 30px;
        }
      }

      .neirong {
        margin-left 10px;

        .name {
          color #333333;
          font-size 14px;
          font-weight 500
        }

        .ping {
          margin-top 5px;
          color #ccc;
        }

        .shijian {
          margin-top 5px;
          color #ccc;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/wode/Place.vue